/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {
  useCallback,
  useEffect,
  useState
} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AccountLink, User} from '@ion/core/src/types/entities';
import {UserMoveEditor} from '@ion/dls/src/editors/UserMoveEditor';
import {
  userMoveResultSelector,
  userMoveSelectedUsersSelector,
  userMoveShowLoadingSelector
} from './selector';
import {moveAdminUsers, moveUsers} from './state';

export interface BulkUserEditorProps {
  isCtcAdmin?: boolean;
  globalGroup?: AccountLink;
  setItemSelected?: Function
}

/**
 * BulkEditUserEditor
 *
 */
export const BulkEditUserEditor = ({
  globalGroup,
  setItemSelected = () => {},
  isCtcAdmin = false
}: BulkUserEditorProps) => {
  const dispatch                  = useDispatch();
  const [clearForm, setClearForm] = useState(false);
  const selectedUsers             = useSelector(userMoveSelectedUsersSelector);
  const editedUsers               = useSelector(userMoveResultSelector);
  const loading                   = useSelector(userMoveShowLoadingSelector);

  useEffect(() => {
    if (editedUsers) {
      setClearForm(true);
      dispatch(moveAdminUsers(null, false));
    }
  }, [editedUsers]);

  const onSave = useCallback((users: User[]) => {
    dispatch(moveUsers(users));
    setItemSelected(false);
  }, []);

  const onCancel = useCallback(() => {
    dispatch(moveAdminUsers(null, false));
  }, []);

  return (
    <UserMoveEditor open
      account={globalGroup}
      users={selectedUsers}
      clear={clearForm}
      loading={loading}
      isCtcAdmin={isCtcAdmin}
      onSave={onSave}
      onCancel={onCancel} />
  );
};

export default BulkEditUserEditor;
